export default __webpack_public_path__ + "static/media/aliexpress_logo_icon_247663.bb2e4e1e.webp";